import { VdsButton, VdsIcon } from '@volt/volt-extended-components-react';
import { ReactElement } from 'react';

type VdsButtonProps = React.ComponentProps<typeof VdsButton>;

interface ButtonWithIconProps {
  icon: string;
  label: string;
  onClick: () => void;
  variant?: VdsButtonProps['variant'];
  disabled?: boolean;
}

export const ButtonWithIcon = ({
  icon,
  label,
  onClick,
  variant = 'primary',
  disabled = false,
}: ButtonWithIconProps): ReactElement => {
  return (
    <VdsButton
      variant={variant}
      size="medium"
      isFullWidth={false}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
      <VdsIcon slot="icon-left" svgIcon={icon} />
    </VdsButton>
  );
};

export default ButtonWithIcon;
